import React from "react";
import "./openSec.css";
import video from "../../media/images/openSecVid.mp4";

const OpenSec = () => {
    return (
        <section id="openSec">
            <video autoPlay loop muted playsInline id="background-video">
                <source src={video} type="video/mp4" />
                הדפדפן שלך לא תומך בוידאו.
            </video>
            <div className="overlay"></div>
            <div className="content">
                <h1 data-aos="fade-up" className="head">
                    בתים וגנים
                </h1>
                <p data-aos="fade-up" className="p">
                    מעצבים ומבצעים פתרונות מאלומיניום ברזל ועץ​ מרעיון למציאות -
                    מלווים אתכם בכול התהליך. ייעוץ והכרות עם כל מה שיש לשוק
                    להציע. תוכלו לבחור בביטחון את המתאים והנכון לכם ביותר,
                    בהתחשב בכלל הצרכים והאופי העיצובי.
                </p>
            </div>
        </section>
    );
};

export default OpenSec;
